export default "__VITE_ASSET__CIGu855m__"